// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import paymentTableData from "layouts/managePayment/data/paymentTableData";
import add from "assets/images/add.png";
import { useNavigate } from "react-router-dom";
import ChatScreen from "components/ChatScreen";
import DiscountForm from "components/Discount";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import { useGetPaymentHistoryMutation } from "services/payment";
import { useEffect, useState } from "react";
import MDBadge from "components/MDBadge";
import Pagination from "components/Pagination";
import moment from "moment";
import { useLazyGetPaymentsQuery } from "services/payment";
import { useWithdrawPaymentMutation } from "services/payment";
import useTranslation from "hooks/Translation";

const ManagePayments = () => {
  const t = useTranslation();
  const [getPaymentHistory] = useGetPaymentHistoryMutation();
  const [getPayments] = useLazyGetPaymentsQuery();
  const [withdrawPayment] = useWithdrawPaymentMutation();
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [totalPayments, setTotalPayments] = useState("");
  const [amount, setAmount] = useState("");

  function formatRevenue(labelValue) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + " B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + " M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + " K"
      : Math.abs(Number(labelValue));
  }

  const totalPages = Math.ceil(totalRecords / limit);
  const getData = async (page) => {
    try {
      let body = {
        start: page,
        length: 10,
        search: "",
      };

      const res = await getPaymentHistory(body).unwrap();
      if (res?.status === 200) {
        setPaymentData(res?.data?.response_object || []);
        setTotalRecords(res?.data?.total_records);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getMyPayments = async () => {
    try {
      const res = await getPayments({}).unwrap();
      if (res?.status === 200) {
        setTotalPayments(res?.data || "");
      } else {
        setTotalPayments("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const requestPayment = async (page) => {
    try {
      let body = {
        amount: 100,
        current_date: new Date().toISOString(),
      };

      const res = await withdrawPayment(body).unwrap();
      if (res?.status === 200) {
        setPaymentData(res?.data?.response_object || []);
        setTotalRecords(res?.data?.total_records);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const columns = [
    { Header: t.main.orderNumber, accessor: "author", align: "left" },
    { Header: t.main.amount, accessor: "price", align: "left" },
    { Header: t.main.status, accessor: "status", align: "center" },

    { Header: t.main.date, accessor: "stock", align: "left" },
    //   { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = paymentData?.map((item) => ({
    author: <Job title={item?.id} />,
    price: (
      <Job
        title={`AED ${
          item?.amount_pay_to_vendor ? item?.amount_pay_to_vendor : "0"
        }`}
      />
    ),
    status: (
      <MDBox>
        <MDBadge
          badgeContent="Completed"
          color="success"
          variant="gradient"
          size="md"
        />
      </MDBox>
    ),
    stock: <Job title={moment(item?.order_placed_date).format("MM/DD/YYYY")} />,
  }));

  useEffect(() => {
    getData(page);
  }, [page]);

  useEffect(() => {
    getMyPayments();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={4} xl={3}>
            <DefaultInfoCard
              icon="money"
              title={t.main.totalPayments}
              //   description="Belong Interactive"
              value={
                totalPayments?.pending_payments
                  ? formatRevenue(totalPayments?.pending_payments)
                  : ""
              }
              color="theme-1"
            />
          </Grid>
          <Grid item xs={12} md={4} xl={3}>
            <DefaultInfoCard
              icon="money"
              title={t.main.pendingPayments}
              //   description="Belong Interactive"
              value={
                totalPayments?.pending_payments
                  ? formatRevenue(totalPayments?.total_payments)
                  : ""
              }
              color="theme-1"
            />
          </Grid>

          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                // variant="gradient"
                bgColor="theme-1"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white">
                  {t.main.paymentHistory}
                </MDTypography>

                <MDTypography
                  onClick={requestPayment}
                  variant="h6"
                  color="white"
                  sx={{
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  {t.main.withdraw}
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
              {paymentData?.length > 0 && (
                <MDBox p={2}>
                  <Pagination
                    setPage={setPage}
                    module={paymentData}
                    page={page}
                    onPageChange={setPage}
                    totalPages={totalPages}
                    limit={limit}
                    setLimit={setLimit}
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>

    // <DashboardLayout>
    //   <DashboardNavbar />
    //   <ChatScreen/>
    //   <DiscountForm />
    // </DashboardLayout>
  );
};

export default ManagePayments;
